/* np-difference — ported from the Replo homepage "NattyPLUS difference"
   block (data-rid e5c0f3cc-9158-40b7-b46d-be794c51801f).

   Two independent 1-per-page looping carousels:
     [data-np-diff-logos] product logos in the middle column. The source
       has no nav controls for it, so it advances on a timer.
     [data-np-diff-cards] the feature cards, shown only under 640px where
       the two side columns are display:none. Driven by prev/next buttons.

   Both render their slide set three times and normalise the active index
   back into the middle copy after each move, so the loop is seamless. */
(function () {
  'use strict';

  var DURATION = 300;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

  function makeCarousel(root, opts) {
    var track = root.querySelector('[data-np-diff-track]');
    if (!track) return null;

    var originals = Array.prototype.slice.call(track.children);
    var realCount = originals.length;
    if (!realCount) return null;

    function cloneSet() {
      var frag = document.createDocumentFragment();
      originals.forEach(function (s) {
        var c = s.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('tabindex', '-1');
        frag.appendChild(c);
      });
      return frag;
    }
    if (realCount > 1) {
      track.appendChild(cloneSet());
      track.insertBefore(cloneSet(), track.firstChild);
    }

    var all = Array.prototype.slice.call(track.children);
    var realStart = realCount > 1 ? realCount : 0;
    var active = realStart;
    var animating = false;

    function step() {
      return all.length > 1 ? all[1].offsetLeft - all[0].offsetLeft : root.clientWidth;
    }

    function render(animate) {
      track.style.transition = animate ? 'transform ' + DURATION + 'ms ' + EASING : 'none';
      track.style.transform = 'translate3d(' + -active * step() + 'px, 0, 0)';
      all.forEach(function (s, i) {
        s.setAttribute('data-active', i === active ? 'true' : 'false');
      });
    }

    function normalise() {
      if (realCount > 1) {
        while (active < realStart) active += realCount;
        while (active >= realStart + realCount) active -= realCount;
        render(false);
      }
      animating = false;
    }

    function go(delta) {
      if (animating) return;
      animating = true;
      active += delta;
      render(true);
      var done = false;
      function onEnd(e) {
        if (e && e.propertyName !== 'transform') return;
        if (done) return;
        done = true;
        track.removeEventListener('transitionend', onEnd);
        normalise();
      }
      track.addEventListener('transitionend', onEnd);
      setTimeout(onEnd, DURATION + 60);
    }

    if (opts.prev) opts.prev.addEventListener('click', function () { go(-1); });
    if (opts.next) opts.next.addEventListener('click', function () { go(1); });

    /* Swipe */
    var sx = 0, touching = false;
    track.addEventListener('touchstart', function (e) {
      touching = true; sx = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (!touching) return;
      touching = false;
      var dx = (e.changedTouches[0] || {}).clientX - sx;
      if (Math.abs(dx) > 40) go(dx < 0 ? 1 : -1);
    });

    var raf = null;
    window.addEventListener('resize', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { render(false); });
    });

    render(false);

    if (opts.autoplayMs && realCount > 1) {
      var timer = null;
      function start() {
        if (timer) return;
        timer = setInterval(function () {
          if (document.hidden) return;
          go(1);
        }, opts.autoplayMs);
      }
      function stop() {
        clearInterval(timer);
        timer = null;
      }
      /* pause while hovered, resume on leave — the old version cleared the
         interval on first mouseenter and never restarted it. */
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });
      start();
    }
    return { go: go };
  }

  function initRoot(root) {
    if (!root || root.dataset.npDiffInit === 'true') return;
    root.dataset.npDiffInit = 'true';

    var logos = root.querySelector('[data-np-diff-logos]');
    if (logos) {
      makeCarousel(logos, {
        autoplayMs: parseInt(root.dataset.npDiffLogoInterval, 10) || 3000
      });
    }

    var cards = root.querySelector('[data-np-diff-cards]');
    if (cards) {
      makeCarousel(cards, {
        prev: cards.querySelector('[data-np-diff-prev]'),
        next: cards.querySelector('[data-np-diff-next]')
      });
    }
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-np-diff]');
    Array.prototype.forEach.call(roots, initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
